import type { ProductData } from '@ori/analytics-data';
import type { GlobalProductQuerySignalsDto } from '@ori/global-api-client-react';

import { PACKAGE_NAME } from '../constants';
import type { Product, SuggestionsAndResults } from '../models';
import { getSearchTime } from './getSearchTime';

export const analytics = {
  formatProduct: ({
    ActualPriceUnformated,
    ConceptName,
    CurrencyCode,
    GtmBrand,
    GtmCategory,
    ProductCode,
    ProductImageUrl,
  }: Product): ProductData => ({
    currency: CurrencyCode,
    globalBrandName: '',
    globalCategoryName: '',
    globalName: '',
    itemCode: ProductCode,
    localBrandName: GtmBrand,
    localCategoryName: GtmCategory,
    localName: ConceptName,
    media: [ProductImageUrl],
    price: ActualPriceUnformated,
  }),
  getSignalsData: ({
    customerId,
    position,
    results,
    timestamp,
  }: {
    customerId: number;
    position: number;
    results: SuggestionsAndResults;
    timestamp: number;
  }): GlobalProductQuerySignalsDto => ({
    params: {
      count: 1,
      docId: results.Products[position]?.ProductCode,
      filterQueries: ['products'],
      position: position + 1,
      query: results.Query,
      queryId: results.QueryId,
      searchTime: getSearchTime(timestamp),
      sessionId: results.OnlineSessionId,
      source: PACKAGE_NAME,
      totalHits: results.Products.length,
      userId: customerId.toString(),
    },
    timeStamp: new Date(),
    type: 'click',
  }),
};
